
import { useDocumentData } from 'react-firebase-hooks/firestore';
import Firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { UserRole } from '../utils/permissions';

export default function useShopCallPolicyConfig(shopId, role) {

    const ref = shopId && role === UserRole.admin ? Firebase.firestore().collection('shops').doc(shopId).collection('installData').doc('callsPolicy') : null;
    const [callPolicyConfig, callPolicyConfigLoading, callPolicyConfigError] = useDocumentData(ref);
    return { callPolicyConfig, callPolicyConfigLoading, callPolicyConfigError }
}
